import { Icon, IconsEnum } from 'components/Icons';

import { AnchorLink } from 'components/anchorLink';
import styles from './IppicaTableRowMainInfoContent.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaTableRowMainInfoContentProps = {
  descrizioneRiunione: string;
  tipoGara: string;
  streamingUrl?: string;
  href?: string;
};

export const IppicaTableRowMainInfoContent = ({
  descrizioneRiunione,
  tipoGara,
  streamingUrl,
  href,
}: IppicaTableRowMainInfoContentProps) => {
  const { isMobile } = useWindowSize();

  return (
    <>
      <div className={styles.wrapper} suppressHydrationWarning>
        {href ? (
          <AnchorLink href={href} className={styles.textWrapper}>
            <span className={styles.text}>{descrizioneRiunione}</span>
          </AnchorLink>
        ) : (
          <p className={styles.textWrapper}>
            <span className={styles.text}>{descrizioneRiunione}</span>
          </p>
        )}

        <span className={styles.secondaryText}>{tipoGara}</span>
      </div>

      <div className={styles.iconsWrapper} suppressHydrationWarning>
        {streamingUrl &&
          (isMobile ? (
            <span className={styles.streamingLink}>
              <Icon iconId={IconsEnum.STREAMING} className={styles.iconTv} color="var(--color-on-bg-secondary)" />
            </span>
          ) : (
            <AnchorLink href={streamingUrl} className={styles.streamingLink}>
              <Icon iconId={IconsEnum.STREAMING} className={styles.iconTv} color="var(--color-on-bg-secondary)" />
            </AnchorLink>
          ))}
        {isMobile && (
          <Icon iconId={IconsEnum.CHEVRON_RIGHT} className={styles.iconChevron} color="var(--color-on-bg-primary)" />
        )}
      </div>
    </>
  );
};
